import { defineType } from 'sanity';

export const productShowcase = defineType({
    name: 'productShowcase',
    title: 'Product Showcase section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'products',
            title: 'Products',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'name',
                            title: 'Product Name',
                            type: 'localizedString',
                        },
                        {
                            name: 'description',
                            title: 'Product Description',
                            type: 'localizedString',
                        },
                        {
                            name: 'price',
                            title: 'Price',
                            type: 'localizedString',
                        },
                        {
                            name: 'image',
                            title: 'Product Image',
                            type: 'seoOptimizedImageUrl',
                        },
                    ],
                },
            ],
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Product Showcase: ${title['en'] || title['sr']}`,
            };
        },
    },
});
